export default "__VITE_ASSET__CnGocYEp__"